import { render, staticRenderFns } from "./BreakdownTable.vue?vue&type=template&id=1f79210c&"
import script from "./BreakdownTable.vue?vue&type=script&lang=ts&"
export * from "./BreakdownTable.vue?vue&type=script&lang=ts&"
import style0 from "./BreakdownTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports